import React from "react";

const ContentStats = ({ stats }) => {
  return (
    <div className="bg-white rounded-8 px-20 py-15 shadow-3">
      <div className="d-flex items-center x-gap-15">
        <div className="text-center">
          <div className="text-18 fw-600 text-purple-1">{stats.totalExams}</div>
          <div className="text-11 text-light-1">Exams</div>
        </div>
        <div className="text-center">
          <div className="text-18 fw-600 text-blue-1">{stats.totalSubjects}</div>
          <div className="text-11 text-light-1">Subjects</div>
        </div>
        <div className="text-center">
          <div className="text-18 fw-600 text-green-1">{stats.totalVideos}</div>
          <div className="text-11 text-light-1">Videos</div>
        </div>
        <div className="text-center">
          <div className="text-18 fw-600 text-orange-1">{stats.totalMaterials}</div>
          <div className="text-11 text-light-1">Materials</div>
        </div>
        <div className="text-center">
          <div className="text-18 fw-600 text-red-1">{stats.totalTests}</div>
          <div className="text-11 text-light-1">Tests</div>
        </div>
      </div>
    </div>
  );
};

export default ContentStats; 